import { render, staticRenderFns } from "./HelpBox.vue?vue&type=template&id=535f5c52"
import script from "./HelpBox.vue?vue&type=script&lang=ts"
export * from "./HelpBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports